var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaadinPassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2518_13837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 6.25C20.5 5.5 20 5 19.25 5H1.75C1 5 0.5 5.5 0.5 6.25V13.75C0.5 14.5 1 15 1.75 15H19.25C20 15 20.5 14.5 20.5 13.75V6.25ZM19.25 13.75H1.75V6.25H19.25V13.75Z",
    fill: "#374655"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10C8 10.3315 7.8683 10.6495 7.63388 10.8839C7.39946 11.1183 7.08152 11.25 6.75 11.25C6.41848 11.25 6.10054 11.1183 5.86612 10.8839C5.6317 10.6495 5.5 10.3315 5.5 10C5.5 9.66848 5.6317 9.35054 5.86612 9.11612C6.10054 8.8817 6.41848 8.75 6.75 8.75C7.08152 8.75 7.39946 8.8817 7.63388 9.11612C7.8683 9.35054 8 9.66848 8 10ZM11.75 10C11.75 10.3315 11.6183 10.6495 11.3839 10.8839C11.1495 11.1183 10.8315 11.25 10.5 11.25C10.1685 11.25 9.85054 11.1183 9.61612 10.8839C9.3817 10.6495 9.25 10.3315 9.25 10C9.25 9.66848 9.3817 9.35054 9.61612 9.11612C9.85054 8.8817 10.1685 8.75 10.5 8.75C10.8315 8.75 11.1495 8.8817 11.3839 9.11612C11.6183 9.35054 11.75 9.66848 11.75 10ZM15.5 10C15.5 10.3315 15.3683 10.6495 15.1339 10.8839C14.8995 11.1183 14.5815 11.25 14.25 11.25C13.9185 11.25 13.6005 11.1183 13.3661 10.8839C13.1317 10.6495 13 10.3315 13 10C13 9.66848 13.1317 9.35054 13.3661 9.11612C13.6005 8.8817 13.9185 8.75 14.25 8.75C14.5815 8.75 14.8995 8.8817 15.1339 9.11612C15.3683 9.35054 15.5 9.66848 15.5 10Z",
    fill: "#374655"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2518_13837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaadinPassword);
export default __webpack_public_path__ + "static/media/vaadin_password.ffd9b97694f5341afee5a2c043028918.svg";
export { ForwardRef as ReactComponent };